export default __webpack_public_path__ + "static/media/edit-icon.839f8630.svg";